export default __webpack_public_path__ + "static/media/cmc.e5e18a7f.png";